"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleEvent = handleEvent;
exports.useEventHandlers = useEventHandlers;

var _react = require("react");

var inlinkOutlinkPattern = new RegExp(/^ga-/i);

function findClosestAnchorAncestor(element) {
  if (element.tagName === "A") {
    return element;
  }

  return element.closest("a");
}

function handleEvent(anchor, tealium) {
  var id = anchor.getAttribute("id") || anchor.getAttribute("data-id");
  var dataTealiumId = anchor.getAttribute("data-tealium-id");

  if (!(id && inlinkOutlinkPattern.test(id)) && !dataTealiumId) {
    return;
  }

  tealium.link({
    event_name: "link_click",
    link_id: dataTealiumId || id,
    link_url: anchor.getAttribute("href")
  });
}

function configureMouseDownHandler(tealium) {
  return function (event) {
    // Use Element over HTMLElement to cover SVG tags as well
    if (!(event.target instanceof Element)) {
      return;
    }

    var anchor = findClosestAnchorAncestor(event.target);

    if (!anchor) {
      return;
    }

    handleEvent(anchor, tealium);
  };
}

function configureKeydownHandler(tealium) {
  return function (event) {
    var key = event.key,
        target = event.target;

    if (key !== "Enter" || !(target instanceof HTMLElement) || target.tagName !== "A") {
      return;
    }

    handleEvent(target, tealium);
  };
}

function useEventHandlers(tealium) {
  (0, _react.useEffect)(function () {
    if (typeof window === "undefined") {
      return;
    }

    var mouseDownHandler = configureMouseDownHandler(tealium);
    var keyDownHandler = configureKeydownHandler(tealium); // Using mousedown event can result in false-positives, but has the added
    // benefit of also capturing "right-click" events.

    document.addEventListener("mousedown", mouseDownHandler);
    document.addEventListener("keydown", keyDownHandler);
    return function () {
      document.removeEventListener("mousedown", mouseDownHandler);
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, [tealium]);
}
//# sourceMappingURL=events.js.map